import React from 'react';

import { LoaderDots, Text } from '@reservamos/elements';
import { useTranslation } from 'react-i18next';
import ModalWithTheme from 'components/ModalWithTheme';
import RedeemPointsMethods from './RedeemPointsMethods';
import RedeemCodeForm from './RedeemCodeForm/RedeemCodeForm';
import { useRedeemContext } from '../RedeemHandlerContext';

const RedeemPointsConfirmationModal = () => {
  const { codeSent, isCreating, isConfirming, onClose } = useRedeemContext();
  const isProcessing = isConfirming || isCreating;

  const { t } = useTranslation('payment');

  return (
    <ModalWithTheme
      responsiveSize="S"
      onCloseModal={onClose}
      closeOnOverlayClick={!isProcessing}
      rounded="M"
    >
      {isConfirming ? (
        <div className="flex flex-col gap-[10px] justify-center items-center h-full min-h-[300px]">
          <Text size="XXL" weight="bold">
            {t('label.verifying_code')}
          </Text>
          <LoaderDots isAccent size="M" />
        </div>
      ) : (
        <div className="flex flex-col gap-4 pt-1 pb-3">
          <Text size="XXL" weight="bold">
            {!codeSent ? t('label.confirm_use_wallet') : t('label.enter_code')}
          </Text>
          {!codeSent ? <RedeemPointsMethods /> : <RedeemCodeForm />}
        </div>
      )}
    </ModalWithTheme>
  );
};

export default RedeemPointsConfirmationModal;
